import React from 'react';
import './ModalDC.css'; 

const ModalDC = ({ patient, onClose }) => {
  return (
    <div className="modal-overlay-modalDc">
      <div className="modal-container-modalDc">
        <button className="close-modal-button-ModalDC" onClick={onClose}>X</button>
        <h3 className='heading-patient'>Patient Details</h3>
        <p><strong className='stronger'>Name:</strong> {patient.patientName}</p>
        <p><strong className='stronger'>Date of Birth:</strong> {patient.dob}</p>
        <p><strong className='stronger'>Age:</strong> {patient.age}</p>
        <p><strong className='stronger'>Gender:</strong> {patient.gender}</p>
        <p><strong className='stronger'>Diagnosis:</strong> {patient.diagnosis}</p>
        <p><strong className='stronger'>Admission Date:</strong> {patient.admissionDate}</p>
        <p><strong className='stronger'>Discharge Date:</strong> {patient.dischargeDate}</p>
        <h3 className='heading-patient'>Medications:</h3>
        <table className="medication-table-DC">
          <thead>
            <tr>
              <th>Medication</th>
              <th>Prescribed Quantity</th>
              <th>Consumed Quantity</th>
              <th>Total Cost (Rs)</th>
              <th>Company</th>
            </tr>
          </thead>
          <tbody>
            {patient.medications.map((med, index) => (
              <tr key={index}>
                <td>{med.medicationName}</td>
                <td>{med.prescribedQuantity}</td>
                <td>{med.consumedQuantity}</td>
                <td>₹{med.totalCost}</td>
                <td>{med.company}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ModalDC;
